var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDirection, useFieldProps, useForm, useFormRefs, useTextFieldError } from '../hooks';
import FormHelperText from './FormHelperText';
var FormSwitch = function (_a) {
    var id = _a.id, dir = _a.dir, description = _a.description, rest = __rest(_a, ["id", "dir", "description"]);
    var classes = useStyles();
    var form = useForm();
    var innerRef = useFormRefs();
    var fieldProps = useFieldProps(id);
    var fieldError = useTextFieldError(id);
    var direction = useDirection();
    var handleChange = useCallback(function (value) {
        form.setFieldValue(id, value, true);
        form.setFieldTouched(id);
    }, [form, id]);
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: classes.container }, { children: [_jsx(Switch, __assign({ id: id, dir: dir || direction, inputRef: function (el) { if (innerRef)
                            innerRef.current[id] = el; } }, fieldProps, { checked: form.values[id], color: "primary", onChange: function (e) { handleChange(e.target.checked ? 1 : 0); } }, rest), void 0),
                    _jsx(InputLabel, __assign({ className: classes.InputLabel, htmlFor: id }, { children: description }), void 0)] }), void 0),
            _jsx(FormHelperText, { text: fieldError, error: true }, void 0)] }, void 0));
};
export default FormSwitch;
var useStyles = makeStyles(({
    inputRoot: {
        width: '100%'
    },
    container: {
        display: 'flex'
    },
    InputLabel: {
        fontFamily: "Assistant-Bold",
        display: 'flex',
        alignItems: 'center'
    }
}));
//# sourceMappingURL=FormSwitch.js.map